import script from "./ConfiguracionesGenerales.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfiguracionesGenerales.vue?vue&type=script&setup=true&lang=js"

import "./ConfiguracionesGenerales.vue?vue&type=style&index=0&id=5ae6cfc4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae6cfc4"]])

export default __exports__